export const JWT_TOKEN_KEY = 'winefoToken';
